export const message = {
  top: {
    nav1: "首页",
    nav2: "公司介绍",
    nav3: "酒店 · 旅馆",
    nav3Sub: "专注宿泊事业，提供安心、舒适的住宿体验",
    nav4: "赴日旅居&投资并购",
    nav4Sub: "为对日投资、跨境贸易等商务需求提供全程全方位咨询服务",
    nav5: "数字营销&IT开发",
    nav5Sub: "为拓展中国市场的企业提供网络广告等数字营销一站式服务",
    nav6: "联系我们",
  },
  bottom: {
    lang1: "简体中文",
    lang2: "日本語",
    companyName: "盘古日本株式会社",
    email: "邮箱：info-jp@pangod.com",
    address: "地址：东京都港区高轮4-6-10-103",
    office: "品川OFFICE：东京都港区高轮4-6-10-103",
    copyText: "保留所有权利",
    privacy: "隐私政策",
    privacyPolicy: "个人信息保护方针",
    supportText: "技术支持",
    supportCompany: "盘古广告",
  },
  home: {
    title: "目标成为住宿行业的运营专家",
    titleLine1: "目标成为住宿行业的",
    titleLine2: "运营专家",
    subTitleLine1: "致力于专业的酒店与旅馆运营，",
    subTitleLine2: "为每一位宾客提供舒适、安心的住宿体验。",
    subTitle:
      "致力于专业的酒店与旅馆运营，为每一位宾客提供舒适、安心的住宿体验。",
    btnText: "了解更多",
  },
  intro: {
    title: "公司简介",
    subTitle: "专注宿泊事业，提供安心、舒适的住宿体验",
    more: "更多",
    type1: {
      title: "盘古纵横集团",
      company: "PANGOO GROUP",
      desc: "盘古纵横集团成立于2003年，由原盘古网络有限公司发展而来。我们以「客户至上、用心服务、诚信经营、追求卓越」为经营理念，致力于为客户提供高质量、多元化的服务。集团总部设在中国成都，在四川、重庆、山西、广东和日本等多地设有分支机构。业务涵盖广告服务、技术支持、金融与地产服务、酒店及旅游服务等多个领域。目前，集团旗下拥有盘古广告、盘古信息、盘古情报、盘古典当、日本PANGOO酒店、盘古纵横国际旅行社等多个业务板块，并持续拓展服务品牌，提升整体服务价值。",
    },
    type2: {
      title: "盘古日本株式会社",
      company: "BANKO NIHON",
      desc: "盘古日本株式会社成立于2020年，总部位于日本东京，专注于酒店、旅馆及住宿设施的运营管理。我们致力于为来自世界各地的宾客提供安心、舒适的住宿体验，支持多语言服务，提供细致周到的服务，让每一位宾客都能享受到便捷、安心的住宿时光。我们致力于打造兼具地域魅力与高质量服务的住宿设施，满足国内外宾客「想再次入住」的需求，为宾客提供安心、舒适、高质量的住宿体验。",
    },
    feature1: {
      title: "专业运营",
      desc1: "应对多种设施类型",
      desc2: "拥有丰富的运营经验",
    },
    feature2: {
      title: "安心 · 安全",
      desc1: "严格遵守法律法规",
      desc2: "完善风险管理体系，安心的运营体制",
    },
    feature3: {
      title: "多语言 · 多文化支持",
      desc1: "提供多语言服务",
      desc2: "热情接待来自世界各地的宾客",
    },
    feature4: {
      title: "24小时支持服务",
      desc1: "为您的安心与便捷",
      desc2: "提供24小时支持服务",
    },
  },
  manager: {
    title: "我们的理念",
    subTitle: "专注于住宿事业，为您提供安心舒适的住宿体验。",
    type1: {
      title: "品川",
      subTitle: "pangoo品川",
      desc: "位于港区高轮，步行至品川站约6分钟，闹中取静，周边环境安全舒适的高品质住宅区。从品川站可自由搭乘JR 8条线路，交通便利。此外，前往大阪、名古屋等主要城市也可搭乘新干线，交通十分便利。无论是前往羽田机场或成田机场，交通直达，非常便捷。明亮宽敞的室内空间，干净整洁，致力于为您提供明亮舒适的居住体验。",
      room: "房间数量：共35间，最多可容纳2~3人",
      addrTitle: "地址",
      addr: {
        addr1: "東京都港区高輪4-6-10",
        addr2: "东京都港区高轮4-6-10",
        addr3: "Takanawa 4-6-10, Minato-ku, Tokyo, Japan",
      },
      trafficTitle: "交通方式",
      traffic: {
        traffic1: "JR「品川」站 步行约6分钟",
        traffic2: "都营浅草线「高轮台」站 步行约10分钟",
        traffic3: "JR「东京」站：搭乘京滨东北线，约20分钟可到达",
        traffic4: "「涩谷」站：搭乘山手线，约23分钟可到达",
        traffic5: "「东京塔」：搭乘都营浅草线，约30分钟可到达",
        traffic6: "从酒店步行4分钟即可到达便利店",
      },
      linkList: [
        {
          name: "booking预定",
          href: "https://www.booking.com/hotel/jp/biyurogao-lun.zh-cn.html",
        },
        {
          name: "airbnb预定",
          href: "https://zh.airbnb.com/rooms/658157619198664961",
        },
      ],
    },
    type2: {
      title: "惠比寿红",
      subTitle: "pangoo惠比寿红",
      desc: "惠比寿是东京非常受欢迎且具有雅典气质的高级居住地区，临近也有很棒的餐馆。夜间恵比寿横丁狭窄的入口处耀眼的霓虹灯闪烁着，长长的小巷里满是红灯笼酒馆，拥挤热闹。每一个酒馆都很特别，所以最棒的选择就是从这家喝到那家，尽情享受。",
      room: "房间：1栋一户建，容纳2-4人",
      addrTitle: "地址",
      addr: {
        addr1: "東京都渋谷区恵比寿3-9-3",
        addr2: "东京都涩谷区惠比寿3-9-3",
        addr3: "Ebisu3-9-3, Shibuya-ku, Tokyo, Japan",
      },
      traffic: {
        traffic1: "JR山手线、埼京线「惠比寿」站：步行7分钟",
        traffic2: "东京METRO日比谷线「惠比寿」站：步行8分钟",
        traffic3: "羽田机场：步行和单轨-山手线42分钟",
        traffic4: "成田机场：步行和京成SKY liner-山手线75分钟",
        traffic5: "此外，步行2分钟即可抵达便利店！",
      },
      linkList: [
        {
          name: "booking预定",
          href: "https://www.booking.com/hotel/jp/the-villa-ebisuhui-bi-shou-yi-tu-bu-8fen-jing-kanazhu-zhai-di.zh-cn.html",
        },
        {
          name: "airbnb预定",
          href: "https://www.airbnb.jp/rooms/1305625660777542372",
        },
      ],
    },
    type2b: {
      title: "惠比寿蓝",
      subTitle: "pangoo惠比寿蓝",
      desc: "惠比寿是东京非常受欢迎且具有雅典气质的高级居住地区，临近也有很棒的餐馆。夜间恵比寿横丁狭窄的入口处耀眼的霓虹灯闪烁着，长长的小巷里满是红灯笼酒馆，拥挤热闹。每一个酒馆都很特别，所以最棒的选择就是从这家喝到那家，尽情享受。",
      room: "房间：1栋一户建，容纳2-4人",
      addrTitle: "地址",
      addr: {
        addr1: "東京都渋谷区恵比寿3-9-3",
        addr2: "东京都涩谷区惠比寿3-9-3",
        addr3: "Ebisu3-9-3, Shibuya-ku, Tokyo, Japan",
      },
      traffic: {
        traffic1: "JR山手线、埼京线「惠比寿」站：步行7分钟",
        traffic2: "东京METRO日比谷线「惠比寿」站：步行8分钟",
        traffic3: "羽田机场：步行和单轨-山手线42分钟",
        traffic4: "成田机场：步行和京成SKY liner-山手线75分钟",
        traffic5: "此外，步行2分钟即可抵达便利店！",
      },
      linkList: [
        {
          name: "booking预定",
          href: "https://www.booking.com/hotel/jp/the-villa-ebisuhui-bi-shou-yi-tu-bu-8fen-jing-kanazhu-zhai-di-blue.zh-cn.html",
        },
        {
          name: "airbnb预定",
          href: "https://www.airbnb.jp/rooms/1304800134346302899",
        },
      ],
    },
    type3: {
      title: "箱根-满来",
      subTitle: "pangoo箱根-满来",
      desc1:
        "箱根位于神奈川县西部，以优质丰富的温泉资源闻名，被群山湖泊所环抱，是日本著名的风景游览区及热门的温泉疗养胜地。满来坐落于箱根温泉一等地段——仙石原，为宾客提供安心、舒适的住宿体验。",
      desc2:
        "满来别墅位于箱根温泉一等地段——仙石原，坐拥2122㎡巨大庭院，优质天然温泉直接入户，独享私人氧吧。雅致的日式传统别墅，空调地暖设备齐全，四季都能享受舒适的生活空间。",
      room: "房间：全屋共7个房间，最大可容纳15人",
      addrTitle: "地址",
      addr: {
        addr1: "神奈川县足柄下郡箱根町仙石原1285-358",
        addr2: "神奈川県足柄下郡箱根町仙石原1285-358",
        addr3:
          "1285-358 Sengokuhara, Hakone, Ashigarashimo District, Kanagawa 250-0631",
      },
      traffic: {
        traffic1: "箱根登山巴士「小塚入口」站：步行4分钟",
        traffic2: "羽田机场：京急机场线-东海道山阳新干线-箱根登山巴士85分钟",
        traffic3: "成田机场：成田快线-东海道山阳新干线-箱根登山巴士105分钟",
        traffic4: "东京站：东海道山阳新干线-箱根登山巴士75分钟",
        traffic5: "新宿站：小田急浪漫特快-箱根登山巴士100分钟",
      },
      linkList: [
        {
          name: "booking预定",
          href: "https://www.booking.com/hotel/jp/mi-mi-hua-yuan-xiang-gen-si-tang-wen-quan-du-jia-bie-shu.zh-cn.html",
        },
        {
          name: "airbnb预定",
          href: "https://www.airbnb.jp/rooms/753179090454896784",
        }
        
      ],
    },
    /* 以下物业 Tab 已下线，保留文案备查
    type4: {
      title: "箱根-玫瑰城堡",
      subTitle: "pangoo箱根-玫瑰城堡",
      desc1:
        "玫瑰城堡位于箱根仙石原温泉核心区域，距离著名的ススキ草原步行只要2分钟。",
      desc2:
        "这是一栋独洋式建筑，外观是红色与绿色的砖墙，复古浪漫，优质仙石原温泉直引，真正的源泉温泉，男女泡池分开，屋前空地可免费停车，后院有庭院景观。",
      room: "房间：全屋共7个房间，最大可容纳16人",
      addrTitle: "地址",
      addr: {
        addr1: "神奈川県足柄下郡箱根町仙石原1246-130",
        addr2:
          "1246-130 Sengokuhara, Hakone, Ashigarashimo District, Kanagawa 250-0631",
      },
      traffic: {
        traffic1: "箱根登山巴士「仙石原高原」站：步行2分钟",
        traffic2: "羽田机场：京急机场线-东海道山阳新干线-箱根登山巴士100分钟",
        traffic3: "成田机场：成田快线-东海道山阳新干线-箱根登山巴士150分钟",
        traffic4: "东京站：东海道山阳新干线-箱根登山巴士85分钟",
        traffic5: "新宿站：小田急高速巴士直达135分钟",
      },
      linkList: [
        {
          name: "airbnb预定",
          href: "https://www.airbnb.jp/rooms/868354830467219526?source_impression_id=p3_1686637224_EIKnTJiILpf4RHEI",
        },
        { name: "BOOKING", href: "https://www.booking.com/Share-AQUbyzi" },
      ],
    },
    type5: {
      title: "伊豆",
      subTitle: "pangoo伊豆",
      desc1:
        "【PeacefulMoon】温泉别墅位于伊豆城崎海岸附近，步行3分钟即可到达门协吊桥。",
      desc2: "这是一栋地中海风格的建筑，外观田园清新，庭院里可容纳5车停车位。",
      desc3: "城崎海岸是代表伊东地区的观光名所，是知名的悬疑剧取景地。",
      desc4: "悬崖峭壁上的吊桥、可以眺望海岸全景的灯塔都是必打卡之地！",
      room: "房间：全屋共6间卧室，2间温泉室，4个卫生间，最大可容纳16人",
      addrTitle: "地址",
      addr: {
        addr1: "静岡県伊東市富戸842-173",
        addr2: "842-173 Futo, Itō, Shizuoka 413-0231",
      },
      traffic: {
        traffic1: "自驾、出租车：",
        traffic2: "从东京方向东名高速厚木IC出发约2小时",
        traffic3: "从爱知方向长泉沼津IC出发约1小时30分",
        traffic4: "徒步：从伊豆急行线城崎海岸站徒步约35分钟",
      },
      linkList: [
        {
          name: "airbnb预定",
          href: "https://www.airbnb.jp/rooms/883693044329307885?source_impression_id=p3_1686637197_gQGfFttcIIW31PRZ",
        },
        { name: "BOOKING", href: "https://www.booking.com/Share-zO7Srw" },
      ],
    },
    type6: {
      title: "冲绳",
      subTitle: "pangoo冲绳",
      desc1:
        "恩纳村和风旅馆坐落于冲绳本岛58号公路旁，门前100米即是公交站，交通便利。",
      desc2: "所有房间均为和式房间，全部铺设榻榻米，干净利落。",
      desc3:
        "黄金位置，出门即是免费海滩，与ANA洲际、凯悦、星野BEB5共望一片海。",
      room: "房间：旅馆共27个房间，每个房间可容纳2-3人",
      addrTitle: "地址",
      addr: {
        addr1: "沖縄県恩納村字恩納398-3",
        addr2: "398-3 Onna, Kunigami District, Okinawa 904-0411",
      },
      traffic: {
        traffic1: "自驾、出租车：",
        traffic2:
          "从那霸机场乘坐高速公路，到屋嘉IC约50分钟，从屋嘉IC沿着国道58号线向北约10分钟。",
        traffic3: "停车场：免费。",
        traffic4: "公交车：",
        traffic5:
          "从那霸机场乘坐大巴约2小时，万座海滩前站下车，步行2分钟即可到达。",
      },
      linkList: [
        { name: "AIRBNB", href: "https://www.airbnb.jp/users/show/510409901" },
        { name: "BOOKING", href: "https://www.booking.com/Share-6JG7Se2" },
      ],
    },
    */
  },
  investment: {
    title: "赴日旅居&投资并购",
    subTitle: "对日投资、跨境贸易等全方位咨询服务",
    type1: {
      title: "旅居",
      subTitle: "寻找在日本的second house",
      desc: "从日本购房基础咨询大手建商期房、二手公寓、一户独栋，到实地考察、签约，购房后的装修入住，以及物业缴费和资产税缴纳等各个方面都能为您对接办理。",
    },
    type2: {
      title: "普通公寓投资",
      subTitle: "提供租房运营管理",
      desc: "购置普通公寓进行租赁：根据您对租售比的要求和预估的资产持有周期，为您推荐结合保值与收益较能兼顾的资产。除购房手续外，我们还将为您招租并对应和管理租客，并按时交付租赁收益，对接资产税与所得税的缴纳。",
    },
    type3: {
      title: "民宿酒店投资",
      subTitle: "提供酒店资质及品牌加盟服务",
      desc: "购置可经营的物业，如民宿或酒店进行运营。为您挑选并改造房源，取得相应资质，上线OTA销售和线下管理，并提供品牌加盟服务。",
    },
    type4: {
      title: "移民",
      subTitle: "获得签证资格",
      desc: "在投资基础上，针对您想要取得日本经营管理签证、未来申请永住者的需求，从头为您设计投资方案与资金计划，合理合规，以真实收益获取签证资格。",
    },
    type5: {
      title: "+α",
      subTitle: "其他增值服务",
      desc: "关于您在日本的生活、商务对接、留学、医疗等需求，都可为您提供咨询和服务。",
    },
  },
  development: {
    title: "数字营销&IT开发",
    subTitle: "互联网广告及技术专业服务",
    btnText: "立即咨询",
    type1: {
      title: "搜索引擎",
      desc1: "覆盖95%的网民",
      desc2: "通过关键词",
      desc3: "帮您锁定目标用户",
      desc4: "无点击不收费",
    },
    type2: {
      title: "信息流",
      desc1: "多创意展现形式",
      desc2: "快速传递品牌信息给用户",
      desc3: "轻松带来海量曝光",
    },
    type3: {
      title: "电商平台",
      desc1: "提供网络基础设施",
      desc2: "支付平台等共享资源",
      desc3: "降低商业成本",
      desc4: "助力营销转化",
    },
    type4: {
      title: "SaaS业务",
      desc1: "“基于强大数据技术”",
      desc2: "按需定制互联网营销服务",
      desc3: "极大提升企业营销力",
    },
    type5: {
      title: "技术服务",
      desc1: "提供行业解决方案",
      desc2: "帮助客户成就自身的",
      desc3: "数字化转型",
      desc4: "和在其行业中引导变革",
    },
  },
  contact: {
    title: "联系我们",
    btnText: "提交",
    change: "换一张",
    form: {
      name: "您的姓名",
      nameError: "请输入您的名字",
      email: "您的电子邮箱",
      emailError: "请输入电子邮箱",
      companyName: "贵公司名",
      companyNameError: "请输入贵公司名",
      mobile: "您的电话号码",
      mobileError: "请输入电话号码",
      consultText: "咨询内容",
      consultTextError: "请输入咨询内容",
      code: "验证码",
      codeError: "验证码不正确",
    },
  },
};
